import { type FC } from 'react';
import { LinkType, LINK_TYPE_COLORS } from '@/types/link.types';

interface EdgeContextMenuProps {
  position: { x: number; y: number };
  currentType: LinkType;
  onChangeType: (linkType: LinkType) => void;
  onDelete: () => void;
  onClose: () => void;
}

const linkTypeLabels: Record<LinkType, { label: string; icon: string }> = {
  [LinkType.Hierarchy]: { label: 'Hiérarchie', icon: '↓' },
  [LinkType.Dependency]: { label: 'Dépendance', icon: '⇢' },
  [LinkType.Contribution]: { label: 'Contribution', icon: '+' },
  [LinkType.Contradiction]: { label: 'Contradiction', icon: '⚡' },
  [LinkType.Complementarity]: { label: 'Complémentarité', icon: '∞' },
  [LinkType.FreeForm]: { label: 'Libre', icon: '—' },
};

export const EdgeContextMenu: FC<EdgeContextMenuProps> = ({
  position,
  currentType,
  onChangeType,
  onDelete,
  onClose,
}) => {
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />
      <div
        style={{
          position: 'fixed',
          left: position.x,
          top: position.y,
          zIndex: 100,
          backgroundColor: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg)',
          padding: 'var(--spacing-xs)',
          minWidth: 200,
        }}
      >
        <div
          style={{
            padding: 'var(--spacing-xs) var(--spacing-sm)',
            fontSize: 'var(--font-size-xs)',
            color: 'var(--color-text-muted)',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          Changer le type
        </div>
        {Object.values(LinkType).map((lt) => (
          <button
            key={lt}
            onClick={() => onChangeType(lt)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-sm)',
              width: '100%',
              padding: 'var(--spacing-xs) var(--spacing-sm)',
              backgroundColor: lt === currentType ? `${LINK_TYPE_COLORS[lt]}20` : 'transparent',
              border: 'none',
              borderRadius: 'var(--radius-md)',
              color: 'var(--color-text)',
              fontSize: 'var(--font-size-sm)',
              cursor: 'pointer',
              textAlign: 'left',
              fontWeight: lt === currentType ? 600 : 400,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = `${LINK_TYPE_COLORS[lt]}20`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor =
                lt === currentType ? `${LINK_TYPE_COLORS[lt]}20` : 'transparent';
            }}
          >
            <span
              style={{
                width: 20,
                height: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                backgroundColor: LINK_TYPE_COLORS[lt],
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {linkTypeLabels[lt].icon}
            </span>
            <span>{linkTypeLabels[lt].label}</span>
            {lt === currentType && (
              <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--color-text-muted)' }}>
                ✓
              </span>
            )}
          </button>
        ))}

        <div
          style={{
            height: 1,
            backgroundColor: 'var(--color-border)',
            margin: 'var(--spacing-xs) 0',
          }}
        />

        <button
          onClick={onDelete}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--spacing-sm)',
            width: '100%',
            padding: 'var(--spacing-xs) var(--spacing-sm)',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            color: '#EF4444',
            fontSize: 'var(--font-size-sm)',
            cursor: 'pointer',
            textAlign: 'left',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <span style={{ fontSize: 14, fontWeight: 700 }}>×</span>
          <span>Supprimer la liaison</span>
        </button>
      </div>
    </>
  );
};

export default EdgeContextMenu;
